const actionTypes = {
  SET_TYPE: "seneca/user/userType/SET_TYPE",
  UPDATE_TYPE: "seneca/user/userType/UPDATE_TYPE"
};

export default actionTypes;
